export const GET_CHART_DATA = 'GET_CHART_DATA';

export function getChartData(data) {
  return {
    type: GET_CHART_DATA,
    payload: { list: data },
  }
}



// WEBPACK FOOTER //
// ./src/actions/analytic/index.js